const PRODUCT_TICKET = 'ticket'
const PRODUCT_TABLE = 'table'

export {
    PRODUCT_TABLE,
    PRODUCT_TICKET
}